import { blobticService } from './blobticService';

export interface TrafficEntry {
  TRAF_IDF: number;
  TRAF_DATE: string;
  TRAF_METHOD: string;
  TRAF_PATH: string;
  TRAF_QUERY?: string | null;
  TRAF_STATUS: number;
  TRAF_DURATION_MS: number;
  TRAF_IP?: string | null;
  TRAF_USER_AGENT?: string | null;
  TRAF_USER_IDF?: number | null;
  TRAF_USER_EMAIL?: string | null;
  TRAF_ROUTE?: string | null;
  TRAF_REQUEST_BODY?: string | null;
  TRAF_RESPONSE_BODY?: string | null;
  TRAF_IS_ANOMALY: boolean;
  TRAF_ANOMALY_FLAGS?: string | null;
  TRAF_ANOMALY_DETAIL?: string | null;
  TRAF_CORRELATION_ID?: string | null;
  TRAF_SOURCE?: string | null;
  TRAF_ENVIRONMENT?: string | null;
  TRAF_REQUEST_HEADERS?: string | null;
  TRAF_COUNTRY?: string | null;
}

export interface TrafficStatistics {
  total_requests: number;
  total_anomalies: number;
  avg_duration_ms: number;
  max_duration_ms: number;
  server_errors: number;
  auth_failures: number;
  not_found: number;
  rate_limited: number;
  distinct_ips: number;
  distinct_paths: number;
  distinct_countries?: number;
}

export interface TrafficSelectResult {
  statistics: TrafficStatistics | null;
  data: TrafficEntry[];
}

const TRAFFIC_SELECT_OKEY = 'Blobtic_Sys_User,traffic,select';

export interface TrafficFilters {
  statistics?: boolean;
  hours?: number;
  limit?: number;
  anomaliesOnly?: boolean;
  status?: string;
  ip?: string;
}

export const trafficApi = {
  select: async (params: TrafficFilters): Promise<TrafficSelectResult> => {
    const res = await blobticService.executeZoomRequest<any[]>({
      // boubaker 22/08/2026 - données volatiles (traçage temps réel) : jamais de cache IndexDB
      useCache: false,
      ZoomKey: 'traffic',
      Action: {
        OKey: TRAFFIC_SELECT_OKEY,
        statistics: params.statistics,
        hours: params.hours ?? 24,
        limit: params.limit ?? 200,
        anomaliesOnly: params.anomaliesOnly,
        status: params.status,
        ip: params.ip,
      },
    });
    if (!res || res.success === false) {
      throw new Error(res?.message || "Erreur lors de l'exécution du select.");
    }
    const payload = Array.isArray(res.data) ? res.data[0] : undefined;
    return {
      statistics: (payload?.statistics as TrafficStatistics) || null,
      data: (Array.isArray(payload?.data) ? payload.data : []) as TrafficEntry[],
    };
  },
};

export default trafficApi;
